<template>
    <div style="text-align: left">
        <div class="list">订单信息</div>
        <div class="content">
            <div class="goods">
                <div style="flex:2;display: flex; ">
                    <div class="search">
                        学校名称：<el-select v-model="orderList.schoolName" clearable filterable remote reserve-keyword
                            placeholder="请输入关键词" :remote-method="acquireSchoolName" :loading="loading">
                            <el-option v-for="item in optionsSchoolName" :key="item.value" :label="item.schoolName"
                                :value="item.schoolName">
                            </el-option>
                        </el-select>&nbsp;&nbsp;
                        <!-- 批次名称：<el-input style="width:200px" placeholder="批次名称" clearable v-model="orderList.batchName"
                            :disabled="(orderList.schoolName !== '') ? false : true"></el-input>&nbsp;&nbsp; -->
                        批次名称：<el-input style="width:200px" v-if="orderList.schoolName == ''"
                            v-model.trim="orderList.batchName" clearable placeholder="请选择批次名称"></el-input>
                        <el-select v-model.trim="orderList.batchName" style="width:200px" clearable placeholder="请选择批次名称"
                            v-if="orderList.schoolName != ''">
                            <el-option v-for="item in options" :key="item.batchName" :label="item.batchName"
                                :value="item.batchName">
                            </el-option>
                        </el-select>&nbsp;&nbsp;
                        状态：<el-select clearable placeholder="请选择订单状态" style="width:200px"
                            v-model.trim="orderList.orderStatus">
                            <el-option v-for="(item, index) in orderState" :key="index" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>&nbsp;&nbsp;
                        订单号：<el-input style="width:200px" v-model.trim="orderList.orderCode" clearable
                            placeholder="订单号"></el-input>&nbsp;&nbsp;
                        手机号：<el-input style="width:200px" v-model.trim="orderList.phone" clearable
                            placeholder="手机号"></el-input>&nbsp;&nbsp;
                        <br>
                        学生姓名：<el-input style="width:200px" v-model.trim="orderList.studentName" clearable
                            placeholder="学生姓名"></el-input>&nbsp;&nbsp;



                        开始时间：<div class="startTime">
                            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                v-model="orderList.startBatchTime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>&nbsp;&nbsp;
                        结束时间：<div class="startTime">
                            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="orderList.endBatchTime"
                                format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                :disabled="orderList.startBatchTime === null ? true : false" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        订购学校：<el-select clearable placeholder="请选择订单状态" style="width:200px" v-model.trim="schoolName"
                            @focus="orderingSchool">
                            <el-option v-for="(item, index) in orderingSchoolList" :key="index" :label="item.schoolName"
                                :value="item.schoolName">
                            </el-option>
                        </el-select>&nbsp;&nbsp;

                        <el-button type="primary" style="margin-left:10px" @click="searchList">搜 索</el-button>
                        <el-button type="primary" plain @click="resetList">重 置</el-button>
                        <el-button type="primary" style="margin-left:10px" @click="openOrderExpoit">订单导出</el-button>
                        <el-button type="primary" style="margin-left:10px" @click="openRefundExpoit">退款导出</el-button>
                    </div>
                </div>
            </div>
            <br />

            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :cell-style="{}">
                    <!-- <el-table-column type="selection" width="55">
                    </el-table-column> -->
                    <el-table-column type="index" width="50" label="#" header-align="center">
                    </el-table-column>
                    <el-table-column prop="orderCode" label="订单号" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="schoolName" label="学校名称" width="250" header-align="center" align="center"
                        max-width="500px">
                    </el-table-column>
                    <el-table-column prop="batchName" label="批次名称" width="250" header-align="center" max-width="500px"
                        align="center">
                    </el-table-column>
                    <el-table-column prop="orderStatus" label="状态" width="120" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="orderTotal" label="订单金额(元)" width="120" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="payTime" label="下单时间" width="150" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="refundTime" label="退款时间" width="150" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="phone" label="手机号" width="150" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="studentName" label="学生姓名" width="150" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="refundRemark" label="退款备注" width="200" header-align="center" align="center">
                    </el-table-column>
                    <!-- <el-table-column prop="remark" label="备注" width="200" header-align="center" align="center">
                    </el-table-column> -->
                    <!-- <el-table-column label="备注" header-align="center" align="center" width="150">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="light" :content="scope.row.remark" placement="bottom">
                                <template slot="content">
                                    <p class="notice" style="max-width:180px;">{{ scope.row.remark }}</p>
                                </template>
                                <div class="notice-content"> {{ scope.row.remark }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="操作" header-align="center" align="center" width="260" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="openOrderDetails(scope.row)">详情</el-button>
                            <el-button type="text" size="small" @click="openRefundDialog(scope.row)">退款</el-button>
                            <!-- <el-button type="text" size="small" @click="bbb">退款</el-button> -->
                            <el-button type="text" size="small" @click="modifyInformation(scope.row)">修改信息</el-button>
                            <el-button type="text" size="small" @click="openEditorChild(scope.row)">修改备注</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block1">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="orderList.pageNum"
                    :page-size="orderList.pageSize" layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>


        <el-dialog title="编辑备注" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="订单号" prop="orderCode">
                    <el-input disabled v-model="ruleForm.orderCode"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="orderCode">
                    <el-input v-model="ruleForm.remark" type="textarea" :rows="2"></el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editorChild">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="退款信息" :visible.sync="dialogVisibleRefund" width="30%" :before-close="handleClose">
            <el-form :model="refundInfo" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="订单号" prop="orderCode">
                    <el-input disabled v-model="refundInfo.orderCode"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="orderCode">
                    <el-input v-model="refundInfo.remark" type="textarea" :rows="2"></el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleRefund = false">取 消</el-button>
                <el-button type="primary" @click="_wxRefund">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog title="修改信息" :visible.sync="dialogVisibleInfo" width="30%" :before-close="handleClose">
            <el-form :model="studentInfo" :rules="rules" ref="studentInfo" label-width="100px" class="demo-studentInfo">
                <el-form-item label="姓名" prop="userName">
                    <el-input v-model="studentInfo.userName"></el-input>
                </el-form-item>
                <el-form-item label="年级" prop="grade">
                    <el-select v-model="studentInfo.grade" placeholder="请选择年级">
                        <el-option v-for="(item, index) in actions" :key="index" :label="item.grade" :value="item.grade">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级" prop="className">
                    <el-select v-model="studentInfo.className" placeholder="请选择班级">
                        <el-option v-for="(item, index) in actionsClass" :key="index" :label="item.className"
                            :value="item.className">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                    <el-radio-group v-model="studentInfo.sex">
                        <el-radio :label="0" v-if="(typeof studentInfo.sex === 'number')">女</el-radio>
                        <el-radio :label="1" v-if="(typeof studentInfo.sex === 'number')">男</el-radio>
                        <el-radio :label="'0'" v-if="(typeof studentInfo.sex === 'string')">女</el-radio>
                        <el-radio :label="'1'" v-if="(typeof studentInfo.sex === 'string')">男</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="身高" prop="height">
                    <el-input v-model="studentInfo.height"></el-input>
                </el-form-item>
                <el-form-item label="体重" prop="weight">
                    <el-input v-model="studentInfo.weight"></el-input>
                </el-form-item>
                <el-form-item label="年龄" prop="age">
                    <el-input v-model="studentInfo.age" type="number"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="studentInfo.phone"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="addressContent">
                    <el-input type="textarea" v-model="studentInfo.addressContent"></el-input>
                </el-form-item>
                <!-- <el-form-item label="胸围" prop="bust">
                    <el-input v-model="studentInfo.bust"></el-input>
                </el-form-item>
                <el-form-item label="腰围" prop="waist">
                    <el-input v-model="studentInfo.waist"></el-input>
                </el-form-item>
                <el-form-item label="臀围" prop="hip">
                    <el-input v-model="studentInfo.hip"></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="备注" prop="orderCode">
                    <el-input v-model="studentInfo.remark"></el-input>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleInfo = false">取 消</el-button>
                <el-button type="primary" @click="confirmModification">确 定</el-button>
            </span>
        </el-dialog>


        <!-- 订单导出 -->
        <el-dialog title="订单导出" :visible.sync="dialogFormVisibleExpoit" width="400px">
            <el-form :model="infoExpoit" :rules="rulesExpoit" ref="rulesExpoit" label-width="100px" class="demo-ruleForm">
                <el-form-item label="学校名称" prop="schoolName">
                    <el-select v-model="infoExpoit.schoolName" clearable filterable remote reserve-keyword
                        placeholder="请输入关键词" :remote-method="acquireSchoolName" :loading="loading">
                        <el-option v-for="item in optionsSchoolName" :key="item.value" :label="item.schoolName"
                            :value="item.schoolName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="批次名称" prop="batchId">
                    <el-select v-model="infoExpoit.batchId" clearable placeholder="请选择批次名称" ref="sel">
                        <el-option v-for="item in options" :key="item.value" :label="item.batchName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="配送方式" prop="type">
                    <el-select v-model="infoExpoit.type" placeholder="请选择活动区域">
                        <el-option label="配送到校" value="0"></el-option>
                        <el-option label="配送到家" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.startTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.endTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleExpoit = false">取 消</el-button>
                <el-button type="primary" @click="orderExpoit">确 定</el-button>
            </div>
        </el-dialog>



        <!-- 退款导出 -->
        <el-dialog title="订单导出" :visible.sync="dialogRefundExpoit" width="400px">
            <el-form :model="infoExpoit" ref="rulesExpoit" label-width="100px" class="demo-ruleForm">
                <el-form-item label="开始时间" :rules="rulesExpoit.startTime" prop="startTime">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.startTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" :rules="rulesExpoit.endTime" prop="endTime">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.endTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogRefundExpoit = false">取 消</el-button>
                <el-button type="primary" @click="refundExpoitExpoit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from '../utils/request'
import axios from 'axios';
import exportUrl from '../Api/exportUrl'
import throttling from '../utils/throttling'
export default {
    data() {
        return {
            throttling: () => { },
            exportUrl,
            schoolName: '',
            // 正在订购的学校
            orderingSchoolList: [],
            dialogRefundExpoit: false,
            infoExpoit: {
                schoolName: '',
                batchId: '',
                batchName: '',
                startTime: '',
                endTime: '',
                type: '0'
            },
            dialogFormVisibleExpoit: false,
            orderList: {
                orderCode: '',
                batchName: '',
                schoolName: '',
                phone: '',
                studentName: '',
                endBatchTime: null,
                startBatchTime: null,
                orderStatus: null,
                isPage: true,
                pageNum: 1,
                pageSize: 10
            },
            options: [],
            tableData: [],
            optionsSchoolName: [],
            loading: false,
            orderState: [
                {
                    value: '未支付'
                },
                {
                    value: '付款成功'
                },
                {
                    value: '已到货'
                },
                {
                    value: '政府支付'
                },
                {
                    value: '退款中'
                },
                {
                    value: '已退款'
                },
                {
                    value: '取消支付'
                },
                {
                    value: '取消订单'
                },
                {
                    value: '已关闭'
                },
                {
                    value: '支付失败'
                },
            ],
            total: 0,
            dialogVisible: false,
            ruleForm: {
                id: '',
                remark: '',
                orderCode: ''
            },
            rulesExpoit: {
                schoolName: [
                    { required: true, message: '请输入学校名称', trigger: 'change' },
                ],
                batchId: [
                    { required: true, message: '请输入批次名称', trigger: 'change' },
                ],
                startTime: [
                    { required: true, message: '请输入开始时间', trigger: 'change' },
                ],
                endTime: [
                    { required: true, message: '请输入结束时间', trigger: 'change' },
                ],
                type: [
                    { required: true, message: '请选择配送方式', trigger: 'change' },
                ],
            },
            rules: {
                name: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                    { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                phone: [{ required: true, message: '请输入电话号码', trigger: 'blur' },
                { required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur' }
                ]
            },
            dialogVisibleInfo: false,
            studentInfo: {
                bust: "",
                className: "",
                grade: "",
                height: "",
                hip: "",
                model: "",
                sex: '',
                userName: "",
                waist: "",
                weight: "",
                age: "",
                phone: "",
                addressContent: ""
            },
            orderCode: '',
            actions: [],
            actionsClass: [],
            dialogVisibleRefund: false,
            refundInfo: {
                orderCode: '',
                remark: ''
            }
        }
    },
    methods: {
        // 正在订购学校查询
        async orderingSchool() {
            const res = await request({
                method: 'GET',
                url: 'admin/school/ordering/school'
            })
            if (res.code === '200') {
                this.orderingSchoolList = res.data
            } else {
                this.$message.error(res.message)
            }
        },
        // 退款订单导出窗口
        openRefundExpoit() {
            this.infoExpoit.schoolName = ''
            this.infoExpoit.batchId = ''
            this.infoExpoit.batchName = ''
            this.infoExpoit.startTime = ''
            this.infoExpoit.endTime = ''
            this.dialogRefundExpoit = true
            if (this.$refs['rulesExpoit'] !== undefined) {
                this.$refs['rulesExpoit'].resetFields();
            }
        },
        // 订单导出窗口
        openOrderExpoit() {
            this.infoExpoit.schoolName = ''
            this.infoExpoit.batchId = ''
            this.infoExpoit.batchName = ''
            this.infoExpoit.startTime = ''
            this.infoExpoit.endTime = ''
            this.dialogFormVisibleExpoit = true
            if (this.$refs['rulesExpoit'] !== undefined) {
                this.$refs['rulesExpoit'].resetFields();
            }
        },
        // 退款订单导出文件
        refundExpoitExpoit() {
            this.$refs['rulesExpoit'].validate((valid) => {
                if (valid) {
                    // return
                    axios({
                        method: 'POST',
                        url: exportUrl + 'order/export/refund/order',
                        headers: {
                            'Authorization': 'Bearer ' + sessionStorage.getItem('authorization'),
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        data: {
                            startTime: this.infoExpoit.startTime,
                            endTime: this.infoExpoit.endTime,
                        },
                        responseType: 'blob'
                    }).then((res) => {
                        this.dialogRefundExpoit = false
                        const temp = res.headers['content-disposition'].split(";")[1].split("filename=")[1];
                        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) // res就是接口返回的文件流了
                        let objectUrl = URL.createObjectURL(blob)
                        const a = document.createElement('a')
                        a.download = decodeURIComponent(temp)  //后缀名一定要写对，不然会导致文件损坏，打不开
                        a.href = objectUrl
                        a.click()
                        a.remove()


                    }).catch(() => {
                        this.dialogRefundExpoit = false
                    });
                } else {
                    return false;
                }
            });

        },
        // 订单导出文件
        orderExpoit() {
            this.$refs['rulesExpoit'].validate((valid) => {
                if (valid) {
                    this.infoExpoit.batchName = this.$refs.sel.selectedLabel
                    // return
                    axios({
                        method: 'POST',
                        url: exportUrl + 'order/export/order',
                        headers: {
                            'Authorization': 'Bearer ' + sessionStorage.getItem('authorization'),
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        data: this.infoExpoit,
                        responseType: 'blob'
                    }).then((res) => {
                        this.dialogFormVisibleExpoit = false
                        const temp = res.headers['content-disposition'].split(";")[1].split("filename=")[1];
                        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) // res就是接口返回的文件流了
                        let objectUrl = URL.createObjectURL(blob)
                        const a = document.createElement('a')
                        a.download = decodeURIComponent(temp)  //后缀名一定要写对，不然会导致文件损坏，打不开
                        a.href = objectUrl
                        a.click()
                        a.remove()


                    }).catch(() => {
                        this.dialogFormVisibleExpoit = false
                    });
                } else {
                    return false;
                }
            });

        },
        // 获取列表
        async getOrderList() {
            //console.log(this.orderList);
            const res = await request({
                url: 'admin/order/getOrderList',
                method: 'POST',
                data: this.orderList
            })
            //console.log(res);
            this.schoolName = null
            if (res.code === '200') {
                this.tableData = res.data && res.data.list
                this.total = res.data && res.data.total
            } else {
                this.$message.error(res.message)
            }
        },
        // 模糊查询学校
        async acquireSchoolName(val) {
            //console.log(val !== '');
            this.schoolName = ''
            if (val !== '') {
                this.loading = true
                const res = await request({
                    method: 'POST',
                    url: 'admin/order/getSchoolList',
                    params: { 'schoolName': val }
                })
                //console.log(res)
                if (res.code === '200') {
                    this.loading = false
                    this.optionsSchoolName = res.data
                } else {
                    this.$message.error(res.message)
                }
            } else {

                this.optionsSchoolName = []
            }

        },
        // 搜索
        searchList() {
            this.orderList.pageNum = 1
            if (this.schoolName !== '' && this.schoolName !== null) {
                this.orderList.schoolName = this.schoolName
            }
            this.getOrderList()
        },
        // 修改备注窗口
        async editorChild() {
            this.dialogVisible = false
            const res = await request({
                method: 'POST',
                url: 'admin/order/setOrderRemark',
                // params: {id: this.ruleForm.id},
                data: {
                    id: this.ruleForm.id,
                    remark: this.ruleForm.remark,
                }
            })
            if (res.code === '200') {
                this.$message.success(res.message)
                this.getOrderList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 修改备注
        openEditorChild(val) {
            //console.log(val.remark);
            this.ruleForm.id = val.id
            this.ruleForm.remark = val.remark
            this.ruleForm.orderCode = val.orderCode
            this.dialogVisible = true
        },
        // 查询批次
        async getObtainSchoolBatch(val) {
            const res = await request({
                method: 'GET',
                url: `admin/order/getObtainSchoolBatch?schoolName=${val}`
            })
            if (res.code === '200') {
                this.options = res.data
            }
        },
        // 重置
        resetList() {
            this.orderList.pageNum = 1
            this.orderList.orderCode = ''
            this.orderList.batchName = ''
            this.schoolName = ''
            this.orderList.schoolName = ''
            this.orderList.phone = ''
            this.orderList.studentName = ''
            this.orderList.endBatchTime = null
            this.orderList.startBatchTime = null
            this.orderList.orderStatus = null
            this.orderList.isPage = true
            this.orderList.pageNum = 1
            this.getOrderList()
        },
        //分页
        handleCurrentChange() {
            this.getOrderList()
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                })
                .catch(() => { });
        },
        // 商品详情
        openOrderDetails(val) {
            this.$router.push({ path: '/orderDetails', query: { code: val.orderCode } })
        },
        // 打开修改信息窗口
        async modifyInformation(val) {
            // console.log(val);
            this.actions = []
            this.actionsClass = []
            let studentInfo = JSON.parse(val.studentInfo)
            // console.log(studentInfo);
            studentInfo.phone = val.phone
            studentInfo.addressContent = val.addressContent
            this.studentInfo = studentInfo
            this.dialogVisibleInfo = true
            this.orderCode = val.orderCode
            const res = await request({
                method: 'GET',
                url: `admin/school/select/grade/class?batchId=${val.batchId}`,
                // data: {
                //     batchId: val.batchId,
                //     // orderCode: val.orderCode
                // }
            })
            // console.log(res);
            if (res.code === '200') {
                this.actions = res.data
                this.actions.forEach(item => {
                    if (item.grade === this.studentInfo.grade) {
                        this.actionsClass = item.classAddListVo
                    }
                })
            } else {
                this.$message.error(res.message)
            }
            //console.log(this.studentInfo);
        },
        // 确认修改信息
        confirmModification() {
            this.$refs['studentInfo'].validate(async (valid) => {
                if (valid) {
                    const phone = this.studentInfo.phone
                    const addressContent = this.studentInfo.addressContent
                    delete this.studentInfo.phone
                    delete this.studentInfo.addressContent
                    // console.log(phone);
                    if (phone !== undefined && phone != null && phone.length > 0) {
                        const res = await request({
                            method: 'POST',
                            url: 'admin/order/updOrderStudent',
                            data: {
                                orderCode: this.orderCode,
                                studentInfo: this.studentInfo,
                                phone,
                                addressContent
                            }
                        })
                        //console.log(res);
                        if (res.code === '200') {
                            this.dialogVisibleInfo = false
                            this.$message.success(res.message)
                            this.getOrderList()
                        } else {
                            this.$message.error(res.message)
                            this.studentInfo.phone = phone
                        }
                    } else {
                        this.dialogVisibleInfo = false
                    }

                } else {
                    return
                }
            });
        },
        // 节流退款
        _wxRefund() {
            this.throttling()
        },
        // 打开退款窗口
        openRefundDialog(val) {
            //console.log(val);
            this.refundInfo.orderCode = val.orderCode
            this.refundInfo.remark = ''
            this.dialogVisibleRefund = true
        },
        // 退款
        async wxRefund() {
            const res = await request({
                method: 'POST',
                url: 'admin/wx/business/refund',
                data: this.refundInfo
            })
            if (res.code === '200') {
                this.dialogVisibleRefund = false
                this.$message.success(res.message)
                this.getOrderList()
            } else {
                this.$message.error(res.message)
            }
        }
    },
    created() {
        this.getOrderList()
        this.throttling = throttling(this.wxRefund, 5000)
    },
    beforeRouteLeave(to, from, next) {
        //console.log('路由离开之前', to, from,);
        //console.log(to.name === 'detailsGoods');
        if (to.name === 'orderDetails') {
            //console.log(to.name);
            from.meta.keepAlive = true
        } else {
            from.meta.keepAlive = false
        }
        //console.log(from.$router, '121');
        next()
    },
    watch: {
        'orderList.orderStatus'(val) {
            if (val === '') {
                this.orderList.orderStatus = null
            } else {
                return val
            }
        },
        'orderList.startBatchTime'(val) {
            //console.log(val);
            if (val === '' || val === null) {
                this.orderList.endBatchTime = null
            } else {
                return val
            }
        },
        'orderList.schoolName'(val) {
            if (val !== '' && val !== null) {
                this.getObtainSchoolBatch(val)
            } else if (val === '' || val === null) {
                this.schoolName = null
            }
            // if (val === '' || val === null) {
            //     this.orderList.endOrderTime = null
            // } else {
            //     return val
            // }
        },
        'infoExpoit.schoolName'(val) {
            if (val !== '' && val !== null) {
                this.getObtainSchoolBatch(val)
            }
        },
        'schoolName'(val) {
            if (val !== '' && val !== null) {
                this.getObtainSchoolBatch(val)
            }
        },
        'studentInfo.grade'(val) {
            this.actions.forEach(item => {
                if (item.grade === val) {
                    this.actionsClass = item.classAddListVo
                    this.studentInfo.className = ''
                    this.studentInfo.number = ''
                }
            })
        },
        'studentInfo.className'(val) {
            let p = false
            let active = true
            this.actions.forEach(item => {
                active = false
                if (item.grade === this.studentInfo.grade) {
                    item.classAddListVo.forEach(num => {
                        if (num.className === val) {
                            this.studentInfo.number = num.classSort
                            p = true
                        }
                    })
                }
            })
            if (p || active) {
                return
            } else {
                this.studentInfo.number = '0'
            }
        },
    }
}
</script>


<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
}

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.search {
    line-height: 40px;
}

.block1 {
    background-color: #fff;
    text-align: right;
}

.startTime {
    display: inline-block;
    width: 200px;
    margin-right: 20px;

    .el-date-picker {
        width: 200px;
    }

    input {
        width: 200px;
    }
}

.textarea {
    display: flex;
    justify-content: space-between;
    flex: 100;
    align-items: center;

    .el-textarea.el-input--small {
        flex: 50;
    }
}

.itme {
    line-height: 40px;
    height: 10px;
}

.notice-content {
    height: 20px;
    overflow: hidden;
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>